import * as brands from 'lib/settings/brands'
import { brandLogos } from 'lib/settings/brands'
import { CSSProperties } from 'react'
import { ImageStandAlone as Image } from '../Image/Image'

export type Brand = keyof typeof brands

export interface LogoProps {
  /**
   * The brand to display. Must be a defined brand (`shipplay`, `shipsticks`, etc.)
   */
  brand: Brand
  /**
   * Optional additional classes to apply to the logo
   */
  className?: string
  /**
   * Optional width for the logo. Defaults to the brand's width.
   */
  width?: string
  /**
   * Optional height for the logo. Defaults to the brand's height.
   */
  height?: string

  /**
   * Optional src for the logo. Defaults to the brand's logo.
   */
  src?: string
}

export default function Logo({
  brand,
  className,
  width,
  height,
  src,
}: LogoProps) {
  const ratioWidth = width ?? brands[brand].width
  const ratioHeight = height ?? brands[brand].height

  return (
    <Image
      src={src ?? brandLogos[brand]}
      alt={brand}
      style={
        {
          '--ratio-width': ratioWidth,
          '--ratio-height': ratioHeight,
        } as CSSProperties
      }
      className={className}
      width={ratioWidth}
      height={ratioHeight}
    />
  )
}
